import { Box, Button, Divider, Group, MultiSelect, NumberInput, ScrollArea, SegmentedControl, Text } from '@mantine/core';
import { useForm } from '@mantine/form';
import CustomDatePicker from 'core/components/datePicker/CustomDatePicker';
import { ChannelSelectItem, ChannelValue, FormInputWrapper } from 'core/components/index';
import moment from 'moment';
import { useCallback } from 'react';
import { SETTINGS, shotChannels } from 'utils/constants';
import { getClientLabel } from 'utils/helper';
import { logger } from 'utils/logger';

const FilterPanel = ({ onCancel, onApply, filter, filterItems, company }) => {
    logger.log(filter);
    const form = useForm({
        initialValues: {
            ...filter,
            hasOtbDate: filter.hasOtbDate ?? '',
            otbDate: {
                dateStart: filter.otbDate?.dateStart?.toString().length ? moment(filter.otbDate?.dateStart).toDate() : '',
                dateEnd: filter.otbDate?.dateEnd?.toString().length ? moment(filter.otbDate?.dateEnd).toDate() : '',
            },
            scanDate: {
                dateStart: filter.scanDate?.dateStart?.toString().length ? moment(filter.scanDate?.dateStart).toDate() : '',
                dateEnd: filter.scanDate?.dateEnd?.toString().length ? moment(filter.scanDate?.dateEnd).toDate() : '',
            },
             createdDate: {
                dateStart: filter.createdDate?.dateStart?.toString().length ? moment(filter.createdDate?.dateStart).toDate() : '',
                dateEnd: filter.createdDate?.dateEnd?.toString().length ? moment(filter.createdDate?.dateEnd).toDate() : '',
            },

            pageRange: {
                pageStart: parseInt(filter.pageRange?.pageStart?.toString()) || '',
                pageEnd: parseInt(filter.pageRange?.pageEnd?.toString()) || '',
            },
        },
        validate: {
            pageRange: {
                pageEnd: (value, values) => {
                    const pageStart = values.pageRange?.pageStart;
                    if (pageStart && value && Number(value) < Number(pageStart)) {
                        return 'To page must be greater than or equal to From page';
                    }
                    return null;
                },
            },
        },
    });

    logger.log(form.values);

    // logger.log(filter, filterItems, form.values);
    // useEffect(() => {
    //     if (filter && form) {
    //         form.setValues({ ...filter });
    //     }
    // }, [filter, form]);

    const getFilterVars = useCallback(
        (key) => {
            var res = [];
            if (filterItems[key]) Object.keys(filterItems[key]).forEach((val) => res.push(val));
            return res.sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
        },
        [filter, filterItems],
    );

    const onSegmentChange = (e) => {
        logger.log(e);
    };

    return (
        <Box shadow='xs' style={{ width: '100%' }}>
            <form onSubmit={form.onSubmit((values) => onApply(values))}>
                <ScrollArea.Autosize mah={SETTINGS.FILTER_PANEL_MAX_HEIGHT} className='filter-scroll-content'>
                
                    <FormInputWrapper label='Photo Code' labelWidth={'130px'}>
                        <MultiSelect data={getFilterVars('photoCode')} label='' placeholder='Pick all that you like' searchable nothingFound='Nothing found' {...form.getInputProps('photoCode')} />
                    </FormInputWrapper>
                    <FormInputWrapper label='Sample Size' labelWidth={'130px'}>
                        <MultiSelect data={getFilterVars('sampleSize')} label='' placeholder='Pick all that you like' searchable nothingFound='Nothing found' {...form.getInputProps('sampleSize')} />
                    </FormInputWrapper>
                    <FormInputWrapper label='Style' labelWidth={'130px'}>
                        <MultiSelect data={getFilterVars('shotStyle')} label='' placeholder='Pick all that you like' searchable nothingFound='Nothing found' {...form.getInputProps('shotStyle')} />
                    </FormInputWrapper>
                    <FormInputWrapper label='Department' labelWidth={'130px'}>
                        <MultiSelect data={getFilterVars('department')} label='' placeholder='Pick all that you like' searchable nothingFound='Nothing found' {...form.getInputProps('departments')} />
                    </FormInputWrapper>
                    <FormInputWrapper label='Channels' id='input-channels' labelWidth={'130px'}>
                        <MultiSelect
                            withinPortal={true}
                            data={shotChannels}
                            label=''
                            placeholder='Select channels'
                            searchable
                            nothingFound='Nothing found'
                            itemComponent={ChannelSelectItem}
                            valueComponent={ChannelValue}
                            {...form.getInputProps('channels')}
                        />
                    </FormInputWrapper>
                    <FormInputWrapper label='Origin' id='input-channels' labelWidth={'130px'}>
                        <MultiSelect data={getFilterVars('origins')} label='' placeholder='Pick all that you like' searchable nothingFound='Nothing found' {...form.getInputProps('origin')} />
                    </FormInputWrapper>
                    {/* <FormInputWrapper label='Sessions' labelWidth={'130px'}>
                    <MultiSelect
                        data={getFilterVars('sessions')}
                        label=''
                        placeholder='Pick all that you like'
                        searchable
                        nothingFound='Nothing found'
                        {...form.getInputProps('sessions')}
                    />
                </FormInputWrapper> */}
                    {/* <FormInputWrapper label='Status' id='input-brands' labelWidth={'130px'}>
                    <Stack>
                        <Checkbox label='Sample Acquired' {...form.getInputProps('status.sampleCount', { type: 'checkbox' })} />
                        <Checkbox label='Has Photography' {...form.getInputProps('status.photographyCount', { type: 'checkbox' })} />
                        <Checkbox label='Has Tasks' {...form.getInputProps('status.taskCount', { type: 'checkbox' })} />
                        <Checkbox label='Tasks Completed' {...form.getInputProps('status.completedTaskCount', { type: 'checkbox' })} />
                    </Stack>

                </FormInputWrapper> */}
                
                    <FormInputWrapper label='Scan Date' id='input-scandate' labelWidth={'130px'}>
                        <Group noWrap>
                            <CustomDatePicker sx={{ width: 185 }} placeholder='From Scan Date' {...form.getInputProps('scanDate.dateStart')} />
                            <Text>to</Text>
                            <CustomDatePicker sx={{ width: 185 }} placeholder='To Scan Date' {...form.getInputProps('scanDate.dateEnd')} />
                        </Group>
                    </FormInputWrapper>

                     <FormInputWrapper label='Created Date' id='input-createddate' labelWidth={'130px'}>
                        <Group noWrap>
                            <CustomDatePicker sx={{ width: 185 }} placeholder='From Created Date' {...form.getInputProps('createdDate.dateStart')} />
                            <Text>to</Text>
                            <CustomDatePicker sx={{ width: 185 }} placeholder='To Created Date' {...form.getInputProps('createdDate.dateEnd')} />
                        </Group>
                    </FormInputWrapper>

                    <FormInputWrapper label='Pages' id='input-pages' labelWidth={'130px'}>
                        <Group noWrap align='flex-start'>
                            <NumberInput
                                sx={{ width: 185 }}
                                placeholder='From'
                                min={1}
                                {...form.getInputProps('pageRange.pageStart', {
                                    onChange: (value) => {
                                        form.setFieldValue('pageRange.pageStart', value);
                                        // Re-validate pageEnd when pageStart changes
                                        form.validateField('pageRange.pageEnd');
                                    },
                                })}
                            />
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', height:36 }}>
                                <Text>to</Text>
                            </Box>
                            <NumberInput sx={{ width: 185 }} placeholder='To' min={1} {...form.getInputProps('pageRange.pageEnd')} />
                        </Group>
                    </FormInputWrapper>

                    <Divider />
                    <FormInputWrapper label={`Has ${getClientLabel(company, 'otbDate')}`} id='input-shootdate' labelWidth={'130px'}>
                        <Box sx={{ width: '100%' }}>
                            <SegmentedControl
                                data={[
                                    { label: 'All', value: '' },
                                    { label: 'Yes', value: '1' },
                                    { label: 'No', value: '0' },
                                ]}
                                placeholder='Has OTB Date'
                                {...form.getInputProps('hasOtbDate')}
                            />

                            {form.values.hasOtbDate === '1' ? (
                            <Group noWrap mt='sm'>
                                <CustomDatePicker
                                    sx={{ width: 185 }}
                                    placeholder='From'
                                    disabled={form.values.hasOtbDate === '0'}
                                    {...form.getInputProps('otbDate.dateStart')}
                                />
                                <Text>to</Text>
                                <CustomDatePicker
                                    sx={{ width: 185 }}
                                    placeholder='To'
                                    disabled={form.values.hasOtbDate === '0'}
                                        {...form.getInputProps('otbDate.dateEnd')}
                                    />
                                </Group>
                            ) : null}
                        </Box>
                    </FormInputWrapper>
                    <Divider />
                    <FormInputWrapper label='Has Session' labelWidth={'130px'}>
                        <Box sx={{ width: '100%' }}>
                            <SegmentedControl
                                sx={{ flexShrink: 0 }}
                                data={[
                                    { label: 'All', value: '' },
                                    { label: 'Yes', value: '1' },
                                    { label: 'No', value: '0' },
                                ]}
                                placeholder='Has Session'
                                onChange={(e) => onSegmentChange(e)}
                                {...form.getInputProps('status.hasSession')}
                            />

                            {form.values.status.hasSession === '1' ? (
                                <MultiSelect
                                    mt={'sm'}
                                    sx={{ flexGrow: `1 !important` }}
                                    data={getFilterVars('sessions')}
                                    label=''
                                    placeholder='Pick all that you like'
                                    searchable
                                    nothingFound='Nothing found'
                                    {...form.getInputProps('sessions')}
                                />
                            ) : null}
                        </Box>
                    </FormInputWrapper>
                    <Divider />
                    <FormInputWrapper label='Multi Shot' labelWidth={'130px'}>
                        <SegmentedControl
                            data={[
                                { label: 'All', value: '' },
                                { label: 'Yes', value: '1' },
                                { label: 'No', value: '0' },
                            ]}
                            placeholder='Has Photography'
                            {...form.getInputProps('multiShotFlag')}
                        />
                    </FormInputWrapper>
                    <FormInputWrapper label='Outfitting Available' labelWidth={'130px'}>
                        <SegmentedControl
                            data={[
                                { label: 'All', value: '' },
                                { label: 'Yes', value: '1' },
                                { label: 'No', value: '0' },
                            ]}
                            placeholder='Outfitting Available'
                            {...form.getInputProps('outfittingFlag')}
                        />
                    </FormInputWrapper>
                    <FormInputWrapper label='Sample Acquired' labelWidth={'130px'}>
                        <SegmentedControl
                            data={[
                                { label: 'All', value: '' },
                                { label: 'Yes', value: '1' },
                                { label: 'No', value: '0' },
                            ]}
                            placeholder='Sample Acquired'
                            {...form.getInputProps('status.sampleCount')}
                        />
                    </FormInputWrapper>

                    <FormInputWrapper label='Has Photography' labelWidth={'130px'}>
                        <SegmentedControl
                            data={[
                                { label: 'All', value: '' },
                                { label: 'Yes', value: '1' },
                                { label: 'No', value: '0' },
                            ]}
                            placeholder='Has Photography'
                            {...form.getInputProps('status.photographyCount')}
                        />
                    </FormInputWrapper>

                    <FormInputWrapper label='Has Tasks' labelWidth={'130px'}>
                        <SegmentedControl
                            data={[
                                { label: 'All', value: '' },
                                { label: 'Yes', value: '1' },
                                { label: 'No', value: '0' },
                            ]}
                            placeholder='Has Tasks'
                            {...form.getInputProps('status.taskCount')}
                        />
                    </FormInputWrapper>

                    <FormInputWrapper label='Tasks Complete' labelWidth={'130px'}>
                        <SegmentedControl
                            data={[
                                { label: 'All', value: '' },
                                { label: 'Yes', value: '1' },
                                { label: 'No', value: '0' },
                            ]}
                            placeholder='Tasks Complete'
                            {...form.getInputProps('status.taskCompleteCount')}
                        />
                    </FormInputWrapper>

                    {/* <FormInputWrapper label='Brands' id='input-brands' labelWidth={'130px'}>
                    <MultiSelect data={getFilterVars('brands')} label='' placeholder='Pick all that you like' searchable nothingFound='Nothing found' {...form.getInputProps('brands')} />
                </FormInputWrapper>

                <FormInputWrapper label='Category' id='input-category' labelWidth={'130px'}>
                    <MultiSelect data={getFilterVars('categories')} label='' placeholder='Pick all that you like' searchable nothingFound='Nothing found' {...form.getInputProps('categories')} />
                </FormInputWrapper>

                <FormInputWrapper label='Department' id='input-department' labelWidth={'130px'}>
                    <MultiSelect
                        data={['React', 'Angular', 'Svelte', 'Vue', 'Riot', 'Next.js', 'Blitz.js']}
                        label=''
                        placeholder='Pick all that you like'
                        searchable
                        nothingFound='Nothing found'
                        {...form.getInputProps('department')}
                    />
                </FormInputWrapper>

                <FormInputWrapper label='Location' id='input-location' labelWidth={'130px'}>
                    <MultiSelect
                        data={['React', 'Angular', 'Svelte', 'Vue', 'Riot', 'Next.js', 'Blitz.js']}
                        label=''
                        placeholder='Pick all that you like'
                        searchable
                        nothingFound='Nothing found'
                        {...form.getInputProps('location')}
                    />
                </FormInputWrapper>

                <FormInputWrapper label='Status' id='input-status' labelWidth={'130px'}>
                    <MultiSelect
                        data={['React', 'Angular', 'Svelte', 'Vue', 'Riot', 'Next.js', 'Blitz.js']}
                        label=''
                        placeholder='Pick all that you like'
                        searchable
                        nothingFound='Nothing found'
                        {...form.getInputProps('status')}
                    />
                </FormInputWrapper>

                <FormInputWrapper label='Colour' id='input-colour' labelWidth={'130px'}>
                    <ColorInput placeholder='Pick color' {...form.getInputProps('colour')} />
                </FormInputWrapper>

                <FormInputWrapper label='Assigned Product' id='input-colour' labelWidth={'130px'}>
                    <NativeSelect data={['', 'Yes', 'No']} placeholder='Assigned Product' withAsterisk />
                </FormInputWrapper>

                <FormInputWrapper label='Part of a Season' id='input-assigned-product' labelWidth={'130px'}>
                    <NativeSelect data={['', 'Yes', 'No']} placeholder='Assigned Product' withAsterisk />
                </FormInputWrapper>

                <FormInputWrapper label='Part of an Outfit' id='input-assigned-season' labelWidth={'130px'}>
                    <NativeSelect data={['', 'Yes', 'No']} placeholder='Assigned Product' withAsterisk />
                </FormInputWrapper> */}
                
                </ScrollArea.Autosize>
                <Group position='apart' mt='md' className='action-bar'>
                    <Button variant='default' component='button' size='sm' onClick={() => onCancel()}>
                        Cancel
                    </Button>
                    <Button type='submit' size='sm'>
                        Apply
                    </Button>
                </Group>
            </form>
        </Box>
    );
};

export default FilterPanel;
